export const notificationTypes = {
    SHOW: 'SHOW_NOTIFICATION',
    HIDE: 'HIDE_NOTIFICATION'
};